/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderCalcGlossaryQueryVariables = {||};
export type PGAModelBuilderCalcGlossaryQueryResponse = {|
  +pgaModelCalculationsOverview: ?$ReadOnlyArray<?{|
    +classification: {|
      +id: string,
      +name: string,
    |},
    +name: string,
    +key: string,
    +glossaryEntry: string,
  |}>
|};
export type PGAModelBuilderCalcGlossaryQuery = {|
  variables: PGAModelBuilderCalcGlossaryQueryVariables,
  response: PGAModelBuilderCalcGlossaryQueryResponse,
|};
*/


/*
query PGAModelBuilderCalcGlossaryQuery {
  pgaModelCalculationsOverview {
    classification {
      id
      name
    }
    name
    key
    glossaryEntry
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PGATourModelCalcClassificationType",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "glossaryEntry",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderCalcGlossaryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourModelCalculationType",
        "kind": "LinkedField",
        "name": "pgaModelCalculationsOverview",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PGAModelBuilderCalcGlossaryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourModelCalculationType",
        "kind": "LinkedField",
        "name": "pgaModelCalculationsOverview",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eb4d57c556ec3c0cc3855a9eb0d685e6",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderCalcGlossaryQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderCalcGlossaryQuery {\n  pgaModelCalculationsOverview {\n    classification {\n      id\n      name\n    }\n    name\n    key\n    glossaryEntry\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e3a128dfa1b4c03899b4a9351878b29d';

module.exports = node;
